import { useRecoilState, useRecoilValue } from 'recoil';
import { aiChatBotSessionIdState, deviceUuidState, initialRequestState } from '@/store/atom';
import { Message } from '@/types/discover';
import { useChatbotContext } from '@/pages/Lab/_context/ChatbotContext';
import { useGetAIChatbotAnswer } from '@/hooks/V3/useGetAIChatbotAnswer';
import { RootState, useAppSelector } from '@/redux/store';
import { useLog } from './useLog';

type Origin = 'keyboard_input' | 'action_button';

const EVENT_NAME_MAP: Record<Origin, string> = {
  keyboard_input: 'keyboard_input_request_ai_chatbot',
  action_button: 'action_button_request_ai_chatbot',
};

export const useChatbotActions = (origin: Origin) => {
  const [, setInitialRequest] = useRecoilState(initialRequestState);
  const [sessionId] = useRecoilState(aiChatBotSessionIdState);
  const { setMessages, setInput } = useChatbotContext();
  const { getAiChatBotAnswer } = useGetAIChatbotAnswer();
  const user = useAppSelector((state: RootState) => state.user);
  const { setUserEventHistory } = useLog(user.UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  /** 사용자 메시지 전송 */
  const handleSendMessage = async (messageText?: string, action = '') => {
    const textToSend = messageText || '';
    if (!textToSend && !action) return;

    const newMessage: Message = {
      id: Date.now(),
      text: textToSend || action,
      sender: 'user',
      sessionId,
      action,
    };
    setMessages((prev) => [...prev, newMessage]);
    setInput('');

    await getAiChatBotAnswer({ messageText: textToSend, action });

    setUserEventHistory({
      eventName: EVENT_NAME_MAP[origin],
      eventValue: textToSend || action,
      deviceUuid,
    });

    if (messageText) {
      setInitialRequest('');
    }
  };

  return {
    handleSendMessage,
  };
};
